import {ProgressHeaderWithPopup} from "../components/progressHeaderWithPopup";
import { HeadLogo } from "../components/headLogo";
import {LocationImageDisplay} from "../components/locationImageDisplay";
import {GameIntroHeader} from "../components/gameIntroHeader";
import { CheckMoreButtons } from "../components/checkMoreButtons";
import { ModeIndication } from "../components/modeIndication";

function FactFictionView({
  mode,
  factsData,
  onAnswer,
  onComplete,
  answered,
  feedback,
  currentStep,
  title,
  imageKey,
  answerLabels
}) {


  return (
    <div className="factFiction-layout">
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={currentStep} title={title} />
      <ModeIndication mode={mode} />
      <div className="global-screen-content">
        <GameIntroHeader title="Fact Fiction" description={factsData.Factquestion} />

        <div>
          {factsData.Factoptions.map((opt, idx) => (
            <div key={idx}>
              <button
                className="mindsnap-answer"
                style={
                  answered
                    ? {
                        backgroundColor:
                          opt === factsData.correctAnswer
                            ? "#54C099"
                            : opt === opt
                            ? "#F1B6B6"
                            : "",
                      }
                    : {}
                }
                onClick={() => onAnswer(opt)}
                disabled={answered}
              >
                {answerLabels[idx]}. {opt}
              </button>
            </div>
          ))}
        </div>

        {answered && (
          <>
            <div className="mindsnap-comments">
              <div className="mindsnap-feedback">{feedback}</div>
            </div>

            <CheckMoreButtons onNext={onComplete}/>
          </>
        )}
      </div>
      <LocationImageDisplay imageKey={imageKey} />
    </div>
  );
}

export { FactFictionView };
